"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchField = void 0;
const react_1 = __importStar(require("react"));
const SearchField_styles_1 = require("./SearchField.styles");
const SearchField = ({ value, placeholder, onFocus, onEnter, onClick, onChange }) => {
    const [stateValue, setStateValue] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (stateValue !== value) {
            onChange(stateValue);
        }
    }, [onChange, stateValue, value]);
    const onFocusFn = () => {
        if (onFocus) {
            onFocus();
        }
    };
    const onKeyDownFn = (e) => {
        if (e.key === "Enter" && onEnter) {
            onEnter();
        }
    };
    return (react_1.default.createElement(SearchField_styles_1.ProductSearchBarWrapper, null,
        react_1.default.createElement(SearchField_styles_1.ProductSearchBarInput, { value: stateValue, onChange: (e) => setStateValue(e.target.value), placeholder: placeholder, onFocus: onFocusFn, onKeyDown: (e) => {
                onKeyDownFn(e);
            }, autoFocus: true }),
        react_1.default.createElement(SearchField_styles_1.ProductSearchBarButton, { onClick: onClick })));
};
exports.SearchField = SearchField;
//# sourceMappingURL=SearchField.js.map